import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getAisleBayQuery from '../queries/aislebay/getAisleBayQuery';
import DataProviderContext from '../react/DataProviderContext';
import { useQuery } from './useQuery';

const useAisleBay = ({
  storeSkuIds, storeId, ssr = false, lazy = false, skip = false
}) => {

  const context = useContext(DataProviderContext);
  const sId = storeId || context.storeId || '8119';
  const opts = {
    ssr,
    skip: skip || (!ssr && sId === '8119'),
    errorPolicy: 'all',
    variables: {
      storeSkuIds,
      storeId: sId
    }
  };

  const Query = getAisleBayQuery();
  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);
};

export default useAisleBay;
